module.exports = __webpack_public_path__ + "static/media/event-birthday.b7bc2c43.jpg";